import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useLocation, useParams } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { FaBook, FaVideo } from "react-icons/fa6";
import { IoSchool } from "react-icons/io5";
import { MdQuestionAnswer, MdCallSplit } from "react-icons/md";
import { PiStudentFill } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { LuSchool } from "react-icons/lu";
import { AiOutlineDatabase } from "react-icons/ai";

import { AppContext } from "../../Context";
import { Config } from "../../inc/Config";
import { Loader, GET, NumberFormat } from "../../inc/Fetch";
import { Img, Tasks } from "../../components/Elements";
import Main from "./Main";
import TaskList from "./components/TaskList";


import './css/Home.css'

export default function Site() {

    const { t } = useTranslation();
    const location = useLocation();
    const params = useParams();

    const { userData, siteData } = useContext(AppContext); 
    const [site, setsite] = siteData;
    const [userinfo, setuserinfo] = userData;

    
    let catInfo = site?.cats?.filter(r => r?.name == params?.id);
    let catID = catInfo?.length ? catInfo[0]?._id : false;

    async function loadData() {

        let res = await GET(`home/site?main_article=${catInfo[0]?.main_article?.val}&articles=${catInfo[0]?.articles?.val}`);
        return res;
    }
    
    const { data, error, isLoading } = useQuery(`home_${params?.id}`, loadData); 

    if (isLoading) {
        return <Loader />
    }

    
    
	return (
		<>

        <Main main_article={data?.main_article}>

            <div className='section1'>
                <div className="mainWidth">

                    <div className='mainSectionBox'>
                        <h2>{catInfo[0] ? catInfo[0]?.articles?.name : ""}</h2>
                        <hr />
                    </div>

                    <div className='sectionBody'>
                        {data?.articles?.map((v, k) => { 
  
                            
                            return (
                                <Link to={`/site/${params?.id}/content/${v?._id}`}>
                                    <Img src={v?.img[0]}/>
                                    <h3>{v?.title}</h3>
                                    <p>{v?.short}</p>
                                </Link>
                            );
                        })}
                        

                    </div>
                </div>
            </div>
            
            
            <div className='section4'>
                <div className="mainWidth">
                    
                    <div className='mainSectionBox'>
                        <h2>{t("home_site_tasks")}</h2>
                        <hr />
                    </div>

                    <div className='taskListBox'>
                        {data?.tasks?.map((v, k) => {
                            return(
                                <TaskList v={v} key={k}/>
                            )
                        })}

                    </div>
                </div>
            </div>

            {catInfo?.length && catInfo[0]?.stats?.val ? 
            <div className='section6'>
                <div className="mainWidth">
                    <nav>
                        <li>
                            <PiStudentFill />
                            <b><NumberFormat num={data?.stats?.students} />+</b>
                            <span>{t("tasks_stats_2")}</span>
                        </li>

                        <li>
                            <FaChalkboardTeacher />
                            <b><NumberFormat num={data?.stats?.teachers} />+</b>
                            <span>{t("home_site_teacher_count")}</span>
                        </li>

                        <li>
                            <LuSchool />
                            <b><NumberFormat num={data?.stats?.schools} />+</b>
                            <span>{t("home_site_schools_count")}</span>
                        </li>
                        <li>
                            <AiOutlineDatabase />
                            <b><NumberFormat num={data?.stats?.tasks} />+</b>
                            <span>{t("tasks_title")}</span>
                        </li>
                    </nav>
                </div>
            </div>: false}

            </Main>

		</>
	)
}
